module.exports = __webpack_public_path__ + "media/images/ios-share-fd8bb592fe175806aa499631861b0315.png";